import { http, HttpResponse } from "msw";
import { apiPaths } from "../../api-paths.js";

interface SendTicketHandlerOptions {
  onRequest?: (request: Request) => void | Promise<void>;
  status?: number;
}

const createSendTicketHandlers = ({ onRequest, status = 200 }: SendTicketHandlerOptions = {}) => [
  http.post(`**${apiPaths.customerSupport.createTicket}`, async ({ request }) => {
    await onRequest?.(request);
    return HttpResponse.json({}, { status });
  }),
];

const sendTicketHandlers = createSendTicketHandlers();
const sendTicket500Handlers = createSendTicketHandlers({ status: 500 });

export const customerSupportHandlers = {
  sendTicket: sendTicketHandlers,
  sendTicket500: sendTicket500Handlers,
} as const;

export const customerSupportHandlersFactories = {
  sendTicket: createSendTicketHandlers,
} as const;
